import { __extends } from "tslib";
import React from "react";
import { ActivityIndicator, Text, TouchableOpacity, View } from "react-native";
import PropTypes from "prop-types";
import styles from "./PnmacLoadEarlier.styles.js";
var PnmacLoadEarlier = /** @class */function (_super) {
  __extends(PnmacLoadEarlier, _super);
  function PnmacLoadEarlier() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacLoadEarlier.prototype.renderLoading = function () {
    if (this.props.isLoadingEarlier === false) {
      return /*#__PURE__*/React.createElement(Text, {
        style: [styles.text, this.props.textStyle]
      }, this.props.label);
    }
    return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
      style: [styles.text, this.props.textStyle, {
        opacity: 0
      }]
    }, this.props.label), /*#__PURE__*/React.createElement(ActivityIndicator, {
      color: "white",
      size: "small",
      style: [styles.activityIndicator, this.props.activityIndicatorStyle]
    }));
  };
  PnmacLoadEarlier.prototype.render = function () {
    var _this = this;
    return /*#__PURE__*/React.createElement(TouchableOpacity, {
      style: [styles.container, this.props.containerStyle],
      onPress: function () {
        if (_this.props.onLoadEarlier) {
          _this.props.onLoadEarlier();
        }
      },
      disabled: this.props.isLoadingEarlier === true,
      accessibilityTraits: "button"
    }, /*#__PURE__*/React.createElement(View, {
      style: [styles.wrapper, this.props.wrapperStyle],
      testID: "loadEarlier"
    }, this.renderLoading()));
  };
  return PnmacLoadEarlier;
}(React.Component);
PnmacLoadEarlier.defaultProps = {
  onLoadEarlier: function () {},
  isLoadingEarlier: false,
  label: "Load earlier messages",
  containerStyle: {},
  wrapperStyle: {},
  textStyle: {},
  activityIndicatorStyle: {}
};
PnmacLoadEarlier.propTypes = {
  onLoadEarlier: PropTypes.func,
  isLoadingEarlier: PropTypes.bool,
  label: PropTypes.string,
  containerStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  wrapperStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  textStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  activityIndicatorStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
};
export default PnmacLoadEarlier;